export default __webpack_public_path__ + "static/media/search.d6a8245f.svg";